import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { CommonService } from '../../../../services/common/common.service';
import { FitnessSessionsDataService, FitnessSessionsColumnsService } from '../../../services';
import { FitnessSession, FitnessSessionsResult } from '../../../interfaces';
import { Column } from '../../../interfaces/column.interface';

@Component({
  selector: 'app-fitness-session-details',
  templateUrl: './fitness-session-details.component.html',
  styleUrls: ['./fitness-session-details.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class FitnessSessionDetailsComponent implements OnInit, OnDestroy {

  public fitnessSession: FitnessSession = {};
  public fitnessSessions: FitnessSession[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public columns: Column[] = [];

  constructor(
    private translate: TranslateService,
    private common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private fitnessSessionsDataService: FitnessSessionsDataService,
    private fitnessSessionsColumnsService: FitnessSessionsColumnsService,

  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Fitness Session - Details');
        this.getFitnessSession(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.fitnessSession !== 'undefined') {
      this.fitnessSession = this.dynamicDialogConfig.data.fitnessSession;
    }
    this.columns = this.fitnessSessionsColumnsService.getColumns();
  }

  ngOnDestroy(): void {
  }

  getFitnessSession(id: number): void {
    this.isLoading = true;
    this.fitnessSessionsDataService.getFitnessSession(id).subscribe((response: FitnessSession|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.fitnessSession = response;
      }
    });
  }

  list() {
    this.router.navigate(['/fitness-sessions']);
  }

  add() {
    this.router.navigate(['/fitness-sessions/add']);
  }

  edit() {
    this.router.navigate(['/fitness-sessions/edit/' + this.fitnessSession.id]);
  }

}
@Component({
  selector: 'app-fitness-session-details',
  templateUrl: './fitness-session-details.component.html',
  styleUrls: ['./fitness-session-details.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogFitnessSessionDetailsComponent extends FitnessSessionDetailsComponent {
}

